import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { blog_data } from "../../data/data";

function BlogPost() {
  const { slug } = useParams();
  const postMeta = blog_data.find((p) => p.slug === slug);
  const [content, setContent] = useState("");

  useEffect(() => {
    if (postMeta) {
      fetch(postMeta.file)
        .then((res) => res.text())
        .then((md) => setContent(md));
    }
  }, [postMeta]);

  if (!postMeta) return <Navigate to="/blog" />;

  return (
    <section className="home-header blog-post">
      <h1 className="blog-title">{postMeta.title}</h1>
      <small className="blog-date">Last updated: {postMeta.date}</small>
      <div className="blog-content">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            a: ({ node, ...props }) => (
              <a {...props} target="_blank" rel="noopener noreferrer" />
            ),
          }}
        >
          {content}
        </ReactMarkdown>
      </div>
    </section>
  );
}

export default BlogPost;
